import { Box } from '@mui/material';
import { Header } from 'components/home';
import { ContainerForm } from 'components/shared/container_form';
import InputBooleanFormik from 'components/shared/custom_input_boolean_formik';
import InputLabelFormik from 'components/shared/custom_input_label_formik';
import InputSelectFormik from 'components/shared/custom_input_select_formik';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import { useFormik } from 'formik';
import { ECicaafSituacaoCadastral, ECicaafTipoEntidade, ELocalizacaoUnidade, ICicaafGeneralData } from 'interfaces/cicaaf.interface';
import React from 'react';

export const DadosGeraisCicaaf: React.FC = () => {
    const anoReferencia = 2026;

    const formik = useFormik({
        initialValues: {
            cicaaf_uuid: '',
            entityType: ECicaafTipoEntidade.COOPERADIVA,
            taxId: '',
            nameOrBusinessName: '',
            isCpf: true,
            city: 'Cuiabá',
            hasLegalCaf: null,
            cnpjRegistrationStatus: null,
            unitLocation: null,
            isPartOfAssociation: null,
            associationId: null,
        } as ICicaafGeneralData,
        onSubmit: (values) => {
            console.log(values);
        },
    });


    return (
        <MenuProvider>
            <TopNavBar />
            <Header title={`CICAAF - Dados Gerais - ${anoReferencia}`} showBackButton={true} />
            <Box width='97%' display='flex' flexDirection='column' justifyContent='center' alignItems='center' margin='2rem'>

                <ContainerForm title='Informações Gerais' subtitle='Informe corretamente os dados gerais do CICAAF.' width='1152px'>


                    <Box marginBottom='1rem'>
                        <InputLabelFormik
                            formik={formik}
                            label='entityType'
                            labelTexto='Tipo de Entidade'
                            required={true}
                            disabled={true}
                            version='primary'
                        />
                    </Box>

                    <Box marginBottom='1rem'>
                        <InputLabelFormik
                            formik={formik}
                            label='city'
                            labelTexto='Cidade'
                            required={true}
                            version='primary'
                            disabled={true}
                        />
                    </Box>

                    <Box marginBottom='1rem'>
                        <InputLabelFormik
                            formik={formik}
                            label='taxId'
                            labelTexto={formik.values.isCpf ? 'CPF' : 'CNPJ'}
                            mask={formik.values.isCpf ? 'cpf' : 'cnpj'}
                            maxLength={formik.values.isCpf ? 11 : 14}
                            required={true}
                            placeholder={formik.values.isCpf ? '000.000.000-00' : '00.000.000/0000-00'}
                            version='primary'
                        />
                    </Box>

                    <Box marginBottom='1rem'>
                        <InputLabelFormik
                            formik={formik}
                            label='nameOrBusinessName'
                            labelTexto={formik.values.isCpf ? 'Nome' : 'Razão Social'}
                            required={true}
                            version='primary'
                        />
                    </Box>

                    <Box marginBottom='1rem'>
                        <InputBooleanFormik
                            formik={formik}
                            label='hasLegalCaf'
                            labelTexto='Possui CAF Jurídica?'
                        />
                    </Box>

                    {
                        formik.values.isCpf && (
                            <Box marginBottom='1rem'>
                                <InputSelectFormik
                                    formik={formik}
                                    label='cnpjRegistrationStatus'
                                    labelTexto='Situação Cadastral do CNPJ'
                                    required={true}
                                    placeholder='Selecione a situação cadastral'
                                    options={[
                                        { value: ECicaafSituacaoCadastral.ATIVA, label: 'Ativa' },
                                        { value: ECicaafSituacaoCadastral.SUSPENSA, label: 'Suspensa' },
                                        { value: ECicaafSituacaoCadastral.INAPTA, label: 'Inapta' },
                                        { value: ECicaafSituacaoCadastral.IRREGULAR, label: 'Ativa Não Regular' },
                                        { value: ECicaafSituacaoCadastral.BAIXADA, label: 'Baixada' },
                                        { value: ECicaafSituacaoCadastral.NULA, label: 'Nula' },
                                    ]}
                                />
                            </Box>
                        )
                    }

                    <Box marginBottom='1rem'>
                        <InputSelectFormik
                            formik={formik}
                            label='unitLocation'
                            labelTexto='Localização da Unidade'
                            required={true}
                            placeholder='Selecione a localização da unidade'
                            options={[
                                { value: ELocalizacaoUnidade.RURAL, label: 'Zona Rural' },
                                { value: ELocalizacaoUnidade.URBANA, label: 'Zona Urbana' },
                            ]}
                        />
                    </Box>

                    <Box marginBottom='1rem'>
                        <InputBooleanFormik
                            formik={formik}
                            label='isPartOfAssociation'
                            labelTexto='É parte de uma associação ou cooperativa?'
                        />
                    </Box>

                    {
                        formik.values.isPartOfAssociation && (
                            <Box marginBottom='1rem'>
                                <InputSelectFormik
                                    formik={formik}
                                    label='associationId'
                                    labelTexto='Associação ou Cooperativa'
                                    required={true}
                                    placeholder='Selecione a associação ou cooperativa'
                                    options={[
                                        { value: '1', label: 'Associação 1' },
                                        { value: '2', label: 'Associação 2' },
                                        { value: '3', label: 'Associação 3' },
                                        { value: '4', label: 'Associação 4' },
                                        { value: '5', label: 'Associação 5' },
                                    ]}
                                />
                            </Box>
                        )
                    }
                </ContainerForm>



            </Box>
        </MenuProvider>
    )
}
